module.exports = __webpack_public_path__ + "img/1.29653864.png";